import { render, staticRenderFns } from "./DiagnosticAssistanceView.vue?vue&type=template&id=288fbb9e&scoped=true&"
import script from "./DiagnosticAssistanceView.vue?vue&type=script&lang=ts&"
export * from "./DiagnosticAssistanceView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288fbb9e",
  null
  
)

export default component.exports